import {config} from 'config/env';
import {BasketItemInput, Checkout, PartialCheckoutCreateInput} from 'types';
import {post} from 'utils';

export async function createPartialCheckoutV3(
  input: PartialCheckoutCreateInput,
  basketItem: BasketItemInput[],
  idToken: string
): Promise<Checkout> {
  const endPointURL = `${config.CHECKOUT_API_BASE_URL}/checkout/mpro/api/v3`;
  const response: Checkout = await post(
    endPointURL,
    {...input, basketItem},
    true,
    false,
    true,
    true,
    idToken,
    true,
    true
  );
  return response;
}
